<template lang="pug">
v-dialog(v-model="dialog" width="520" persistent)
  v-card
    v-card-title Crear caso desde matriz
    v-card-subtitle Sube la plantilla del caso con las cantidades por cliente y producto.
    v-card-text
      v-text-field(v-model="caseName" label="Nombre del caso" outlined dense hide-details="auto")
      v-file-input.mt-3(
        v-model="file"
        label="Archivo Excel del caso (.xlsx)"
        accept=".xlsx"
        outlined
        dense
        prepend-icon=""
        prepend-inner-icon="mdi-file-excel-outline"
        :rules="fileRules"
      )
      v-alert.mb-0.mt-1(v-if="errorMsg" dense text type="error") {{ errorMsg }}
      .caption.grey--text.mt-2 Filas = clientes · Columnas = productos/servicios. Hojas "Consumo estimado" (potencial) y "Consumo real".
    v-card-actions
      v-spacer
      v-btn(text @click="close" :disabled="loading") Cancelar
      v-btn(color="primary" depressed :loading="loading" @click="onSubmit") Crear caso
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'CaseMatrixImportFormModal',
  data() {
    return {
      dialog: false,
      loading: false,
      file: null,
      caseName: '',
      errorMsg: '',
      fileRules: [v => !!v || 'Adjunta el archivo del caso'],
    }
  },
  methods: {
    ...mapActions('commercial_projection', ['importCaseMatrix']),
    openDialog() {
      this.file = null
      this.caseName = ''
      this.errorMsg = ''
      this.dialog = true
    },
    close() {
      this.dialog = false
    },
    async onSubmit() {
      this.errorMsg = ''
      if (!this.file) { this.errorMsg = 'Adjunta el archivo del caso.'; return }
      this.loading = true
      const data = new FormData()
      data.append('file', this.file)
      if (this.caseName) data.append('case_name', this.caseName)
      const res = await this.importCaseMatrix({ data })
      this.loading = false
      if (res && res.status >= 200 && res.status < 300 && res.data && res.data.projection_id) {
        this.$toast.success('Caso creado.')
        this.$emit('save', res.data)
        this.close()
      } else {
        const errs = res && res.data && res.data.errors
        this.errorMsg = (errs && errs.length) ? errs.join(' ') : 'No se pudo crear el caso. Revisa que los clientes y productos existan.'
      }
    },
  },
}
</script>
